/**
 * Utility to handle Google Analytics 4 tracking in a Single Page Application (SPA).
 * Intercepts routing changes and manually triggers a 'page_view' event to GA4.
 */

export const initGA4VirtualPageViews = () => {
  if (typeof window === 'undefined') return;

  // Prevent multiple initializations
  if (window.__ga4Initialized) return;
  window.__ga4Initialized = true;

  // Ensure window.gtag is globally accessible
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };

  // Set the initial path so we don't accidentally double-track the exact same path immediately.
  // The first pageview is already fired naturally by the script in index.html!
  let lastTrackedPath = window.location.pathname + window.location.search;

  const trackPageView = () => {
    const currentPath = window.location.pathname + window.location.search;
    
    // Prevent duplicate tracking of the exact same path in rapid succession
    if (currentPath === lastTrackedPath) return;
    lastTrackedPath = currentPath;

    // Small delay (150ms) to ensure React has finished updating the document.title 
    setTimeout(() => {
      // The officially recommended way to send virtual page views in GA4 for SPAs
      // By updating the config with the new path, GA4 automatically fires a fresh page_view
      window.gtag('config', 'G-6HKF9YJJL7', {
        page_path: currentPath,
        page_title: document.title || 'CookiePal',
        page_location: window.location.href
      });
      console.log(`[Analytics] Tracked virtual page_view: ${currentPath}`);
    }, 150);
  };

  // Monkey-patch history.pushState to detect URL changes
  const originalPushState = window.history.pushState;
  window.history.pushState = function() {
    originalPushState.apply(this, arguments);
    trackPageView();
  };

  // Monkey-patch history.replaceState to detect URL (scroll) changes
  const originalReplaceState = window.history.replaceState;
  window.history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    trackPageView();
  };

  // Listen for browser back/forward buttons
  window.addEventListener('popstate', trackPageView);
};